var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mr-auto mt-2 mt-lg-0" }, [
    !_vm.omegaUpLockDown && (!_vm.inContest || _vm.isAdmin)
      ? _c("ul", { staticClass: "navbar-nav align-items-start px-3" }, [
          _vm.isLoggedIn
            ? _c(
                "li",
                {
                  staticClass: "nav-item dropdown nav-contests nav-item-align",
                  class: { active: _vm.navbarSection === "contests" }
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "nav-link px-2 dropdown-toggle",
                      attrs: {
                        href: "#",
                        role: "button",
                        "data-nav-contests": "",
                        "data-toggle": "dropdown",
                        "aria-haspopup": "true",
                        "aria-expanded": "false"
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.T.wordsContests) + " ")]
                  ),
                  _c(
                    "div",
                    { staticClass: "dropdown-menu fullwidth-mobile-fit-lg" },
                    [
                      _vm._t("contests-items", [
                        _c(
                          "a",
                          {
                            staticClass: "dropdown-item",
                            attrs: {
                              href: "/arena/",
                              "data-nav-contests-arena": ""
                            }
                          },
                          [_vm._v(" " + _vm._s(_vm.T.navViewContests) + " ")]
                        ),
                        _vm.isMainUserIdentity
                          ? [
                              _c(
                                "a",
                                {
                                  staticClass: "dropdown-item",
                                  attrs: { href: "/scoreboardmerge/" }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.T.contestsJoinScoreboards) +
                                      " "
                                  )
                                ]
                              ),
                              !_vm.isUnder13User
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "dropdown-item",
                                      attrs: {
                                        href: "/contest/new/",
                                        "data-nav-contests-create": ""
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(_vm.T.contestsCreate) + " "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          : _vm._e()
                      ])
                    ],
                    2
                  )
                ]
              )
            : _c(
                "li",
                { class: { active: _vm.navbarSection === "contests" } },
                [
                  _c(
                    "a",
                    {
                      staticClass: "nav-link px-2",
                      attrs: { href: "/arena/", "data-nav-contests-arena": "" }
                    },
                    [_vm._v(_vm._s(_vm.T.wordsContests))]
                  )
                ]
              ),
          _vm.isLoggedIn
            ? _c(
                "li",
                {
                  staticClass: "nav-item dropdown nav-courses nav-item-align",
                  class: { active: _vm.navbarSection === "courses" }
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "nav-link px-2 dropdown-toggle",
                      attrs: {
                        href: "#",
                        role: "button",
                        "data-nav-courses": "",
                        "data-toggle": "dropdown",
                        "aria-haspopup": "true",
                        "aria-expanded": "false"
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.T.navCourses) + " ")]
                  ),
                  _c(
                    "div",
                    { staticClass: "dropdown-menu fullwidth-mobile-fit-lg" },
                    [
                      _vm._t("courses-items", [
                        _c(
                          "a",
                          {
                            staticClass: "dropdown-item",
                            attrs: {
                              href: "/course/",
                              "data-nav-courses-all": ""
                            }
                          },
                          [_vm._v(" " + _vm._s(_vm.T.navViewCourses) + " ")]
                        ),
                        _vm.isMainUserIdentity && !_vm.isUnder13User
                          ? [
                              _c(
                                "a",
                                {
                                  staticClass: "dropdown-item",
                                  attrs: {
                                    href: "/course/new/",
                                    "data-nav-courses-create": ""
                                  }
                                },
                                [_vm._v(" " + _vm._s(_vm.T.courseCreate) + " ")]
                              )
                            ]
                          : _vm._e()
                      ])
                    ],
                    2
                  )
                ]
              )
            : _c(
                "li",
                {
                  class: { active: _vm.navbarSection === "course" },
                  attrs: { "data-nav-course": "" }
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "nav-link px-2",
                      attrs: { href: "/course/home/" }
                    },
                    [_vm._v(_vm._s(_vm.T.navCourses))]
                  )
                ]
              ),
          _c(
            "li",
            {
              staticClass: "nav-item dropdown nav-problems nav-item-align",
              class: { active: _vm.navbarSection === "problems" }
            },
            [
              _c(
                "a",
                {
                  staticClass: "nav-link px-2 dropdown-toggle",
                  attrs: {
                    href: "#",
                    role: "button",
                    "data-toggle": "dropdown",
                    "data-nav-problems": "",
                    "aria-haspopup": "true",
                    "aria-expanded": "false"
                  }
                },
                [_vm._v(" " + _vm._s(_vm.T.wordsProblems) + " ")]
              ),
              _c(
                "div",
                { staticClass: "dropdown-menu fullwidth-mobile-fit-lg" },
                [
                  _vm._t("problems-items", [
                    _c(
                      "a",
                      {
                        staticClass: "dropdown-item",
                        attrs: {
                          href: "/problem/collection/",
                          "data-nav-problems-collection": ""
                        }
                      },
                      [_vm._v(_vm._s(_vm.T.navViewProblems))]
                    ),
                    _c(
                      "a",
                      {
                        staticClass: "dropdown-item",
                        attrs: {
                          href: "/problem/",
                          "data-nav-problems-list": ""
                        }
                      },
                      [_vm._v(_vm._s(_vm.T.navViewProblemsAll))]
                    ),
                    _c("hr", {
                      staticStyle: {
                        "margin-top": "0em",
                        "margin-bottom": "0em",
                        "border-width": "2px"
                      }
                    }),
                    _c(
                      "a",
                      {
                        staticClass: "dropdown-item",
                        attrs: { href: "/submissions/" }
                      },
                      [_vm._v(_vm._s(_vm.T.navViewLatestSubmissions))]
                    ),
                    !_vm.isLoggedIn
                      ? [
                          _c(
                            "a",
                            {
                              staticClass: "dropdown-item",
                              attrs: { href: "/problem/creator/" }
                            },
                            [_vm._v(_vm._s(_vm.T.createZipFileForProblem))]
                          )
                        ]
                      : [
                          _c("form", { staticClass: "collapse-submenu" }, [
                            _c("div", { staticClass: "btn-group d-flex" }, [
                              _c("span", { staticClass: "dropdown-item" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.T.myproblemsListCreateProblem) +
                                    " "
                                )
                              ]),
                              _c("button", {
                                staticClass:
                                  "btn dropdown-item dropdown-toggle dropdown-toggle-split text-right",
                                attrs: {
                                  type: "button",
                                  "data-toggle": "collapse",
                                  "data-target": ".collapse-links",
                                  "data-nav-problems-create-options": "",
                                  "aria-expanded": "false",
                                  "aria-controls": "collapse-links"
                                }
                              })
                            ]),
                            _c(
                              "div",
                              { staticClass: "collapse collapse-links pl-3" },
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass: "dropdown-item",
                                    attrs: { href: "/problem/creator/" }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.T.myproblemsListCreateZipFileProblem
                                      )
                                    )
                                  ]
                                ),
                                _c(
                                  "a",
                                  {
                                    staticClass: "dropdown-item",
                                    attrs: {
                                      href: "/problem/new/",
                                      "data-nav-problems-create": ""
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.T
                                          .myproblemsListCreateProblemWithExistingZipFile
                                      )
                                    )
                                  ]
                                )
                              ]
                            )
                          ])
                        ],
                    _vm.isReviewer
                      ? _c(
                          "a",
                          {
                            staticClass: "dropdown-item",
                            attrs: { href: "/nomination/" }
                          },
                          [_vm._v(_vm._s(_vm.T.navQualityNominationQueue))]
                        )
                      : _vm._e()
                  ])
                ],
                2
              )
            ]
          ),
          _c(
            "li",
            {
              staticClass: "nav-item dropdown nav-rank nav-item-align",
              class: { active: _vm.navbarSection === "rank" }
            },
            [
              _c(
                "a",
                {
                  staticClass: "nav-link px-2 dropdown-toggle",
                  attrs: {
                    href: "#",
                    role: "button",
                    "data-toggle": "dropdown",
                    "aria-haspopup": "true",
                    "aria-expanded": "false"
                  }
                },
                [_vm._v(" " + _vm._s(_vm.T.navRanking) + " ")]
              ),
              _c(
                "div",
                { staticClass: "dropdown-menu fullwidth-mobile-fit-lg" },
                [
                  _c(
                    "a",
                    { staticClass: "dropdown-item", attrs: { href: "/rank/" } },
                    [_vm._v(_vm._s(_vm.T.navUserRanking))]
                  ),
                  _c(
                    "a",
                    {
                      staticClass: "dropdown-item",
                      attrs: { href: "/rank/authors/" }
                    },
                    [_vm._v(_vm._s(_vm.T.navAuthorRanking))]
                  ),
                  _c(
                    "a",
                    {
                      staticClass: "dropdown-item",
                      attrs: { href: "/rank/schools/" }
                    },
                    [_vm._v(_vm._s(_vm.T.navSchoolRanking))]
                  ),
                  _c(
                    "a",
                    {
                      staticClass: "dropdown-item",
                      attrs: { href: "/coderofthemonth/" }
                    },
                    [_vm._v(_vm._s(_vm.T.navCoderOfTheMonth))]
                  ),
                  _c(
                    "a",
                    {
                      staticClass: "dropdown-item",
                      attrs: { href: "/coderofthemonth/female/" }
                    },
                    [_vm._v(_vm._s(_vm.T.navCoderOfTheMonthFemale))]
                  ),
                  _c(
                    "a",
                    {
                      staticClass: "dropdown-item",
                      attrs: { href: "/schoolofthemonth/" }
                    },
                    [_vm._v(_vm._s(_vm.T.navSchoolOfTheMonth))]
                  )
                ]
              )
            ]
          ),
          _c("li", { staticClass: "nav-item dropdown nav-item-align" }, [
            _c(
              "a",
              {
                staticClass: "nav-link px-2 dropdown-toggle",
                attrs: {
                  href: "#",
                  role: "button",
                  "data-toggle": "dropdown",
                  "aria-haspopup": "true",
                  "aria-expanded": "false"
                }
              },
              [_vm._v(" " + _vm._s(_vm.T.navHelp) + " ")]
            ),
            _c(
              "div",
              { staticClass: "dropdown-menu fullwidth-mobile-fit-lg" },
              [
                _c(
                  "a",
                  {
                    staticClass: "dropdown-item",
                    attrs: {
                      href:
                        "https://www.youtube.com/playlist?list=PLdSCJwXErQ8FhVwmlySvab3XtEVdE8QH4",
                      target: "_blank"
                    }
                  },
                  [_vm._v(_vm._s(_vm.T.navTutorials))]
                ),
                _c(
                  "a",
                  {
                    staticClass: "dropdown-item",
                    attrs: {
                      href: "https://discord.com/invite/K3JFd9d3wk",
                      target: "_blank"
                    }
                  },
                  [_vm._v(_vm._s(_vm.T.navDiscord))]
                ),
                _c(
                  "a",
                  {
                    staticClass: "dropdown-item",
                    attrs: {
                      href: "http://blog.omegaup.com/",
                      target: "_blank"
                    }
                  },
                  [_vm._v(_vm._s(_vm.T.navBlog))]
                ),
                _c(
                  "a",
                  {
                    staticClass: "dropdown-item text-wrap",
                    attrs: {
                      href:
                        "https://drive.google.com/file/d/1PLOO3wLCnOVC_cODwiofahsRGeyoJeCU/view",
                      target: "_blank"
                    }
                  },
                  [_vm._v(_vm._s(_vm.T.navAlgorithmsBook))]
                )
              ]
            )
          ])
        ])
      : _c("ul", { staticClass: "navbar-nav mr-auto" })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }